import { useMemo } from 'react'

import { type SimpleSelectOption } from '@workwave-tidal/core/components'

import { form } from '../../../formState'
import * as OrderTexts from '../../../intl'
import { Props } from '../typings'

const composeValues = ({ statusReasons }: uui.domain.client.rm.Territory, statusReason: string) => {
  const statusReasonsList = statusReasons.map<SimpleSelectOption<string>>(reason => ({
    value: reason,
    label: reason,
  }))

  if (!statusReasons.includes(statusReason)) {
    const outdatedItem = {
      value: statusReason,
      label: statusReason,
    }

    statusReasonsList.unshift(outdatedItem)
    return statusReasonsList
  }

  return statusReasonsList
}

export function ReportedStatusReason(props: Props) {
  const { territory, initialValues } = props
  const initialStatusReason = initialValues.statusReason

  const options: SimpleSelectOption<string>[] = useMemo(() => {
    return composeValues(territory, initialStatusReason || '')
  }, [territory, initialStatusReason])

  return (
    <form.SimpleSelect
      name="statusReason"
      testId="ReportedStatusReason-root"
      label={OrderTexts.getReportedStatusReason()}
      options={options}
    />
  )
}
